import Page404 from '../pages/404';

export default function pageDisable(pageName) {
  return process.env.NEXT_PUBLIC_CHECKOUT_ONLY === 'true' ? Page404 : pageName;
}
